/* AllMinds homepage redesign reveal. Added 2026-09-15. Gated: without JS every .am-rv is visible via CSS. */
(function(){
  if (window.__amHomeInit) return; window.__amHomeInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('.am-rv');
  if (reduce || !('IntersectionObserver' in window)) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('am-in');
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en, i){
      if (en.isIntersecting) {
        var el = en.target;
        setTimeout(function(){ el.classList.add('am-in'); }, Math.min(i * 55, 190));
        io.unobserve(el);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .06 });
  for (var j = 0; j < els.length; j++) io.observe(els[j]);
  // Shopify theme editor re-renders sections; re-observe anything new.
  document.addEventListener('shopify:section:load', function(){
    document.querySelectorAll('.am-rv:not(.am-in)').forEach(function(e){ io.observe(e); });
  });
})();
